"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentsDirectsByDateQueryDto = void 0;
class CurrentsDirectsByDateQueryDto {
    vrmefy;
    online;
    date;
    api_key;
}
exports.CurrentsDirectsByDateQueryDto = CurrentsDirectsByDateQueryDto;
